import Link from 'next/link';
import React from 'react';
import { Container, PropertyNewsIcon } from './AboutPropertyNews.style';

const AboutPropertyNews = () => {
  return (
    <Container>
      <div>
        <h3>About Propertynews.com</h3>

        <p>
          Propertynews is the smart space to find your happy place! Whether you are searching for the perfect property
          to buy or to rent in Northern Ireland, there is no better place to look than Propertynews. We have thousands
          of{' '}
          <b>
            <Link href="/property-for-sale">Houses for sale</Link> and <Link href="/property-to-rent">for rent</Link>{' '}
            throughout Northern Ireland
          </b>
          , with hundreds of new homes added every day.
        </p>

        <p>
          So if you are looking to buy or rent a <Link href="/new-homes/northern-ireland">new home</Link> in{' '}
          <Link href="/property-for-sale/belfast">Belfast</Link>,{' '}
          <Link href="/property-for-sale/londonderry">Derry/Londonderry</Link>,{' '}
          <Link href="/property-for-sale/county-antrim">County Antrim</Link>,{' '}
          <Link href="/property-for-sale/county-armagh">Co. Armagh</Link>,{' '}
          <Link href="/property-for-sale/county-down">Co. Down</Link>,{' '}
          <Link href="/property-for-sale/county-tyrone">Co. Tyrone</Link>, or{' '}
          <Link href="/property-for-sale/county-fermanagh">Fermanagh</Link>, you&apos;ve come to the right place!
        </p>
      </div>

      <PropertyNewsIcon />
    </Container>
  );
};

export default AboutPropertyNews;
